export var ConversationKey;
(function (ConversationKey) {
    ConversationKey["STUDY_CONFIGURATION"] = "study-configuration";
    ConversationKey["SCHEDULE_TIMELINE"] = "schedule-timeline";
    ConversationKey["STUDY_DETAILS"] = "study-details";
    ConversationKey["STUDY_SETTINGS"] = "study-settings";
})(ConversationKey || (ConversationKey = {}));
